/* Caps the reason column so a long reason wraps instead of stretching the table */
.reasonText {
  display: block;
  max-width: 360px;
  white-space: normal;
  word-break: break-word;
}
